const artistListCompactSection = document.getElementsByClassName('artist-list-compact');

if(artistListCompactSection.length > 0) {
    const artistName = artistListCompactSection[0].getElementsByClassName('artist-row');
    const figureImages = artistListCompactSection[0].getElementsByClassName('artist-program-image');

    var screenSizeBig = true;
    var screenWidth = $(window).width();

    $(window).on("load", function() {
        screenWidth = $(window).width();
        if ($(window).width() >= 768){
            screenSizeBig = true;
        } else {
            screenSizeBig = false;
        }
    })

    $(window).on("resize", function() {
        screenWidth = $(window).width();
        if ($(window).width() >= 768){
            screenSizeBig = true;
        } else {
            screenSizeBig = false;
        }
    })

    for (let i = 0; i < artistName.length; i++) {
        artistListCompactSection[0].addEventListener('mousemove', function(event) {
            moveImage(event, i);
        });

        artistName[i].addEventListener('mouseenter', function(event) {
            showImage(i);
        });

        artistName[i].addEventListener('mouseleave', function(event) {
            hideImage(i);
        });
    }


    function moveImage(event, elementNumber) {
        if (screenSizeBig) {
            figureWithImage = figureImages[elementNumber];
            var x = event.pageX;
            x = x+20;
            var y = event.pageY;
            y = y+20;
            console.log(screenWidth);
            if(x<screenWidth-300){
                figureWithImage.style.left = x +'px';
            }
            figureWithImage.style.top = y +'px';
        }
    }

    function showImage(elementNumber){
        if (screenSizeBig) {
            figureWithImage = figureImages[elementNumber];
            figureWithImage.classList.add("artist-program-image-onhover");
        }
    }

    function hideImage(elementNumber){
        if (screenSizeBig) {
            figureWithImage = figureImages[elementNumber];
            figureWithImage.classList.remove("artist-program-image-onhover");
        }
    }
    }